import { Nav } from '@betterment/samba-react';

import TransferNavLink from './TransferNavLink';

import { urlBuilder } from '../../../Shared/urlBuilder';
import { NavLink } from '../nav-link/NavLink';

export const ActivityNav = () => {
  return (
    <>
      <Nav.Separator />
      <Nav aria-label="Your Activity">
        <Nav.List>
          <Nav.ListItem key="performance">
            <NavLink
              to="/performance"
              activeWhen={loc => {
                if (loc.pathname.startsWith('/performance')) return true;

                const isAccountPerformancePage = /^\/account\/.+\/performance$/.test(loc.pathname);
                const returnTo = new URLSearchParams(loc.search).get('returnTo');
                return isAccountPerformancePage && (!returnTo || returnTo === urlBuilder.appPerformance.absolute());
              }}
            >
              <NavLink.Icon name="Bar" />
              <NavLink.Text>Performance</NavLink.Text>
            </NavLink>
          </Nav.ListItem>
          <Nav.ListItem key="activity">
            <NavLink to="/activity">
              <NavLink.Icon name="List" />
              <NavLink.Text>Activity</NavLink.Text>
            </NavLink>
          </Nav.ListItem>
          <Nav.ListItem key="transfers">
            <TransferNavLink />
          </Nav.ListItem>
          <Nav.ListItem key="documents">
            <NavLink to="/documents">
              <NavLink.Icon name="Document" />
              <NavLink.Text>Documents</NavLink.Text>
            </NavLink>
          </Nav.ListItem>
        </Nav.List>
      </Nav>
    </>
  );
};
